export * from './WithFaceDescriptor';
export * from './WithFaceDetection';
export * from './WithFaceExpressions';
export * from './WithFaceLandmarks';
//# sourceMappingURL=index.js.map